import { useEffect, useRef, useState } from "react";
import socketConnection from "../services/socket-io";

// Importar o som diretamente - será incluído no bundle
import alertSound from "../assets/sound.mp3";

/**
 * Hook para gerenciar notificações de novos pedidos
 * Toca som REPETIDAMENTE até aceitar/cancelar o pedido
 */
const useOrderNotification = () => {
    const soundAlertRef = useRef(null);
    const intervalRef = useRef(null);
    const [pendingOrders, setPendingOrders] = useState([]);

    useEffect(() => {
        // Criar elemento de áudio uma única vez
        if (!soundAlertRef.current) {
            soundAlertRef.current = new Audio(alertSound);
            soundAlertRef.current.volume = 1.0;
        }

        // Solicitar permissão de notificação
        if ("Notification" in window && Notification.permission === "default") {
            Notification.requestPermission();
        }

        const socket = socketConnection();

        const handleOrderEvent = (data) => {
            console.log("[useOrderNotification] Order event received:", data);

            if (data.action === "create") {
                // Novo pedido criado - TOCAR SOM REPETIDAMENTE!
                console.log("[useOrderNotification] Starting sound loop for new order");

                // Adicionar à lista de pedidos pendentes
                setPendingOrders(prev => {
                    const newPending = [...prev, data.order.id];

                    // Se é o primeiro pedido pendente, iniciar o loop de som
                    if (prev.length === 0) {
                        startSoundLoop();
                    }

                    return newPending;
                });

                // Mostrar notificação do navegador
                if (Notification.permission === "granted") {
                    const notification = new Notification("🔔 Novo Pedido Recebido!", {
                        body: `Pedido #${data.order.id} de ${data.order.contactName}\nTotal: R$ ${data.order.totalValue}`,
                        icon: "/favicon.ico",
                        badge: "/favicon.ico",
                        tag: `order-${data.order.id}`,
                        requireInteraction: true,
                        silent: false
                    });

                    notification.onclick = () => {
                        window.focus();
                        notification.close();
                    };

                    setTimeout(() => notification.close(), 10000);
                }
            } else if (data.action === "accept" || data.action === "cancel") {
                // Pedido aceito ou cancelado - PARAR SOM SE NÃO HÁ MAIS PENDENTES!
                console.log("[useOrderNotification] Order", data.action, "- checking if should stop sound");

                setPendingOrders(prev => {
                    const newPending = prev.filter(id => id !== data.orderId);

                    // Se não há mais pedidos pendentes, parar o som
                    if (newPending.length === 0) {
                        stopSoundLoop();
                    }

                    return newPending;
                });
            }
        };

        const startSoundLoop = () => {
            console.log("[useOrderNotification] Starting sound loop");

            // Tocar imediatamente
            playSound();

            // Tocar a cada 3 segundos
            intervalRef.current = setInterval(() => {
                playSound();
            }, 3000);
        };

        const stopSoundLoop = () => {
            console.log("[useOrderNotification] Stopping sound loop");

            if (intervalRef.current) {
                clearInterval(intervalRef.current);
                intervalRef.current = null;
            }

            if (soundAlertRef.current) {
                soundAlertRef.current.pause();
                soundAlertRef.current.currentTime = 0;
            }
        };

        const playSound = () => {
            if (soundAlertRef.current) {
                soundAlertRef.current.currentTime = 0;
                soundAlertRef.current.play()
                    .then(() => {
                        console.log("[useOrderNotification] Sound played");
                    })
                    .catch(err => {
                        console.error("[useOrderNotification] Error playing sound:", err);
                    });
            }
        };

        socket.on("order", handleOrderEvent);

        // Cleanup
        return () => {
            socket.off("order", handleOrderEvent);
            stopSoundLoop();
        };
    }, []);

    return {};
};

export default useOrderNotification;
